import type { SiglaProvincia } from '@/api/types';

/**
 * Le sei province pugliesi. È un elenco chiuso e stabile per definizione
 * amministrativa: tenerlo come costante non è un dato inventato, è l'enum
 * `SiglaProvincia` del contratto con nome e slug accanto.
 *
 * `slug` è il segmento URL (`/province/bari/`): è quello a cui puntano i 301
 * generati dal portale statico (`legacyRedirects.generated.ts`), quindi non
 * può essere la sigla.
 *
 * La corrispondenza sigla↔slug è AUTOREVOLE in `GET /api/v2/province/`
 * (§I.13): questa costante è testata contro quella risposta
 * (`province.test.ts`), così una divergenza — come quella di BAT, chiusa
 * dalla decisione 190 con `bat` — rosseggia invece di dormire. La pagina
 * emette `rel="canonical"` sullo slug (decisione 197).
 */
export interface Provincia {
  readonly sigla: SiglaProvincia;
  readonly slug: string;
  readonly nome: string;
}

export const PROVINCE: readonly Provincia[] = [
  { sigla: 'BA', slug: 'bari', nome: 'Bari' },
  { sigla: 'BAT', slug: 'bat', nome: 'Barletta-Andria-Trani' },
  { sigla: 'BR', slug: 'brindisi', nome: 'Brindisi' },
  { sigla: 'FG', slug: 'foggia', nome: 'Foggia' },
  { sigla: 'LE', slug: 'lecce', nome: 'Lecce' },
  { sigla: 'TA', slug: 'taranto', nome: 'Taranto' },
];

/** Risolve il segmento URL in una provincia. `null` = 404, non un errore. */
export function provinciaDaSlug(slug: string): Provincia | null {
  const needle = slug.toLowerCase();
  return (
    PROVINCE.find((p) => p.slug === needle || p.sigla.toLowerCase() === needle) ?? null
  );
}
